import MemberLogin from '~/components/auth/member-login.vue';
import { generateMetaHead } from '~/utils/head';
export default {
  components: {
    MemberLogin
  },
  layout: 'password'
};